"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for the ADD_AND_SET_TOPIC_SERVICE and STREAM_ADD_AND_SET_TOPIC_SERVICE requests.
 */
var AddAndSetTopicRequest = /** @class */ (function () {
    /**
     * Create a new AddAndSetTopicRequest instance
     *
     * @param path  the topic path
     * @param topicSpecification  the topic specification
     * @param value  the value to set the topic to
     * @param constraint  the update constraint
     */
    function AddAndSetTopicRequest(path, topicSpecification, value, constraint) {
        this.path = path;
        this.topicSpecification = topicSpecification;
        this.value = value;
        this.constraint = constraint;
    }
    return AddAndSetTopicRequest;
}());
exports.AddAndSetTopicRequest = AddAndSetTopicRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/add-and-set-topic-request.js
// module id = 1411
// module chunks = 1